<mat-checkbox
    [ngClass]="['mat-option', 'sb-multiselect-check-all']"
    [indeterminate]="isIndeterminate()"
    [checked]="isChecked()"
    (click)="$event.stopPropagation()"
    (change)="toggleSelection($event)"
>
    {{ text }}
</mat-checkbox>
